import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6714d9a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { computed } from "vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'Loading',
  props: {
	size: {
		type: [Number, String],
		default: 80,
	},
	color: {
		type: String,
		default: "#FFF",
	},
	borderSize: {
		type: [Number, String],
		default: 4,
	},
},
  setup(__props) {

const props = __props;



const cssVars = computed(() => {
	const formatSize = (value: number | string): string => {
		if (typeof value === "number") return `${value}px`;
		return value;
	};

	return {
		"--size": formatSize(props.size),
		"--ring-color": props.color,
		"--border-size": formatSize(props.borderSize),
	};
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "loading",
    style: _normalizeStyle(_unref(cssVars))
  }, _hoisted_5, 4))
}
}

})